function weboostClickMore() {
    const moreTextSection = document.getElementById("weboost-moretext-section");
    const button = document.getElementById("weboost-moreless-button-id");

    if (moreTextSection.classList.contains("weboost-toggle-display")) {
        moreTextSection.classList.remove("weboost-toggle-display");
        button.textContent = "Read less";
    } else {
        moreTextSection.classList.add("weboost-toggle-display");
        button.textContent = "Read more";
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.weboost_collection_seo_toggle');
    
    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const desc = this.previousElementSibling;
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            
            if (isExpanded) {
                desc.classList.remove('expanded');
                this.setAttribute('aria-expanded', 'false');
            } else {
                desc.classList.add('expanded');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });

     const questions = document.querySelectorAll(".faq-question");

    questions.forEach((question) => {
      question.addEventListener("click", () => {
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        answer.classList.toggle("show");
      });
    });

  
});